import type { ReactNode } from 'react';

export const symbol_mobile_layout: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-120q-24 0-42-18t-18-42v-108q0-24 18-42t42-18h272q24 0 42 18t18 42v108q0 24-18 42t-42 18H100Zm492 0q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h268q24 0 42 18t18 42v600q0 24-18 42t-42 18H592Zm-492-60h272v-108H100v108Zm492 0h268v-600H592v600Zm134.18-60q12.82 0 21.32-9t8.5-21.5q0-12.5-8.68-21-8.67-8.5-21.5-8.5-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38 0 12 8.68 21 8.67 9 21.5 9ZM100-448q-24 0-42-18t-18-42v-272q0-24 18-42t42-18h272q24 0 42 18t18 42v272q0 24-18 42t-42 18H100Zm182.5-212q12.5 0 21-8.63 8.5-8.62 8.5-21.37 0-12-8.62-21-8.63-9-21.38-9-12 0-21 9t-9 21.5q0 12.5 9 21t21.5 8.5ZM372-506v-274H100v264l71-95q5-6 12-6t12 6l79 105h98ZM236-234Zm490-246ZM236-643Z"
		/>
	</svg>
);
